import React from 'react'
import style from '../card.module.css'
function Math() {
  return (
    <div className={style.syllabus_card}>
    <div>    
        <h3>Mathematics</h3>  
        <p>2 upcoming . 391 courses</p>      
    </div>   
   
        <p>intergral Calculus, Algebra, Differential, Equations and more</p>      
         
    </div>
  )
}
export default Math;